export const removeImageFromContext = (
  step,
  postmortemState,
  memoizedDispatch,

) => {

  let images = null;
  let postmortemSection = "";
  if (step === 0) {
    images = postmortemState.images.incidentSummary;
    postmortemSection = "incidentSummary";
  } else if (step === 1) {
    images = postmortemState.images.rootCause;
    postmortemSection = "rootCause";
  } else if (step === 2) {
    images = postmortemState.images.preventiveCorrectiveMeasures;
    postmortemSection = "preventiveCorrectiveMeasures";
  }else{
    images = postmortemState.images.preventiveCorrectiveMeasures;
    postmortemSection = "preventiveCorrectiveMeasures";
  }
  removeImage(images, postmortemSection, memoizedDispatch, postmortemState);
};

const removeImage = (
  images,
  postmortemSection,
  memoizedDispatch,
  postmortemState
) => {
  if (Object.values(images).some((image) => image.length > 0)) {
    let removeImagesFor = [];

    for (let [key, value] of Object.entries(images)) {
      if (value.length > 0) {
        removeImagesFor.push(key);
      }
    }
    let imagesToBeRemovedFromContext = {};
    let imageFormDataToBeRemovedFromContext = {};
    removeImagesFor.forEach((key) => {
      imagesToBeRemovedFromContext[key] = [];
      imageFormDataToBeRemovedFromContext[key] = new FormData();
    });

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "images",
      payload: {
        ...postmortemState?.images,
        [postmortemSection]: {
          ...postmortemState?.images[postmortemSection],
          ...imagesToBeRemovedFromContext,
        },
      },
    });

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "imageFormData",
      payload: {
        ...postmortemState.imageFormData,
        ...imageFormDataToBeRemovedFromContext
      },
    });
  }
};
